var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-aside__brand kt-grid__item ",attrs:{"id":"kt_aside_brand","kt-hidden-height":"75"}},[_c('router-link',{attrs:{"to":'/dashboard'}},[_c('div',{staticClass:"kt-aside__brand-logo"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }